<div class="phaseNavButton {{ PhaseColorMapping[phase().type] }}" mat-ripple role="button">
	<div class="borderBar"></div>
	<label class="primary heading">
		{{ getPhaseNameLocalizationKey() | translate }}
	</label>
	<section class="duration">
		<span class="iconWrapper">
			<mat-icon fontIcon="fa-timer" fontSet="fas" />
		</span>
		<div class="labelWrapper">
			<label class="secondary">
				{{ T.EXAM_FLOW_DURATION | translate }}
			</label>
			<label class="primary">{{ phase().durationInSeconds * 1000 | durationLabel }}</label>
		</div>

		<sim-recording-status-tag
			#tag
			[isRecording]="phase().isAutomaticRecordingEnabled"
			[matTooltip]="(tag.isRecording() ? T.PHASE_NAV_BUTTON_RECORDED_TOOLTIP : T.PHASE_NAV_BUTTON_NOT_RECORDED_TOOLTIP) | translate"
			[matTooltipClass]="tag.isRecording() ? 'accent' : 'warn'"
			matTooltipPosition="before"
		/>
	</section>
	@if (phase().type === SessionPhaseType.Encounter) {
		<div class="clinicalVignette listItem">
			<label class="secondary">{{ T.LABEL_CLINICAL_VIGNETTE | translate }}</label>
			<span>{{ getClinicalVignetteDuration() | durationLabel }} {{ T.LABEL_MINUTES | translate }} </span>
		</div>
	}
	@if (phase().scheduledSounds?.length) {
		<section class="announcements">
			<div class="listHeading secondary">
				<span>{{ T.EXAM_FLOW_ANNOUNCEMENTS | translate }} ({{ phase().scheduledSounds?.length }})</span>
				<span>{{ T.PHASE_NAV_BUTTON_START_AT | translate }}</span>
			</div>
			<ul>
				@for (announcement of phase().scheduledSounds; track announcement.id) {
					<li class="listItem">
						<div class="gapContainer">
							@let isPlaying = audioElement().isPlaying() && audioElement().currentMediaId() === announcement.mediaId;
							<sim-animated-material-icon
								[startIcon]="{fontIcon: 'fa-play', fontSet: 'fas', themeColor: 'accent'}"
								[endIcon]="{fontIcon: 'fa-pause', fontSet: 'fas', themeColor: 'accent'}"
								[trigger]="isPlaying"
								(click)="isPlaying ? audioElement().stop() : audioElement().play(announcement.mediaId)"
								appStopPropagation
							/>
							<label class="primary">{{ announcement.name }}</label>
							<label class="secondary">{{ $any(announcement?.mediaFile?.metaData[0])?.duration | durationLabel }}</label>
						</div>
						<span>
							{{ announcement | scheduledSoundOffset: phase().durationInSeconds * 1000 | durationLabel }}
						</span>
					</li>
				}
			</ul>
		</section>
	}
</div>
